import React from "react";
import { Link } from "react-router-dom";

const ModificationDiscoveryPage = () => {
  return (
    <section className="subpage-section">
      <div className="container">
        <h1 className="subpage-title">Modification Discovery</h1>
        <p className="subpage-body">
          Discover and prioritize base modifications through integrated analysis
          designed for nanopore sequencing data.
        </p>
        <div className="subpage-visual">
          <div className="subpage-visual-media">
            Placeholder image: modification signal heatmap and ranked candidates
          </div>
          <div className="subpage-visual-notes">
            <h2>What is most useful on this page</h2>
            <ul>
              <li>
                Heatmap or track view that makes signal differences obvious.
              </li>
              <li>
                Candidate-ranking panel with confidence and QC indicators.
              </li>
              <li>
                Validation-ready export example for follow-up experiments.
              </li>
            </ul>
          </div>
        </div>
        <div className="subpage-feature-grid">
          <div className="subpage-feature-card">
            <div className="subpage-card-image-placeholder">
              Placeholder: signal-to-candidate pipeline schematic
            </div>
            <h3>Signal-to-Insight Workflows</h3>
            <p>
              Convert raw signal into candidate modification findings with
              reproducible cloud pipelines.
            </p>
            <Link to="/resources#guides" className="read-more-link">
              Read more
            </Link>
          </div>
          <div className="subpage-feature-card">
            <div className="subpage-card-image-placeholder">
              Placeholder: QC gating and confidence plot
            </div>
            <h3>QC-aware Interpretation</h3>
            <p>
              Evaluate modification calls with built-in quality checks before
              downstream decisions.
            </p>
            <Link to="/resources#faq" className="read-more-link">
              Read more
            </Link>
          </div>
          <div className="subpage-feature-card">
            <div className="subpage-card-image-placeholder">
              Placeholder: large-batch processing overview
            </div>
            <h3>Designed for Scale</h3>
            <p>
              Run discovery workloads without expanding local hardware
              footprint.
            </p>
            <Link to="/waitlist" className="read-more-link">
              Request access
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ModificationDiscoveryPage;
